// 前端 feature flag(依 hostname 判環境,同國中版 chaiwriting-j/utils/featureFlags.js 做法)。

// 自動拉角點:只用在舊的手動四角拖曳視窗(自動預填拉角起點,見 UploadEssay 的
// initializePerspectivePoints),打的是後端 /cornerdetect API。
//
// 2026-08-28(kanban 1000655)起全環境開啟。實際上這條在旋轉動線開啟後是不可達的
// ——initializePerspectivePoints 只在舊的四角拖曳視窗裡跑,而那個視窗被
// !isRotateOnlyFlowEnabled() 擋著。留 true 是為了讓兩個 flag 維持同步(見下),
// 真正退回舊動線時它才會重新生效。
export function isAutoCornerDetectionEnabled(): boolean {
  return true;
}

// 上傳頁「只旋轉」動線(kanban 113663):把手動拉四角的校正視窗換成單欄旋轉視窗,
// 四角校正已搬進批改後端管線內部處理(kanban 114186),前端不再呼叫 /cornerdetect。
//
// 2026-08-28(kanban 1000655)起全環境開啟,不再依 hostname 分歧。
//
// 原本「QA 開、prod 關」的設計造成一個沒人發現的破口:高中單篇的後端**從來沒接過**
// cornerdetect(整支 repo 只有獨立端點自己在用),而前端照「校正已搬進後端」的假設
// 把測試站的校正拿掉了。結果是測試站前後端都不校正、完全沒有校正,正式站反而還有
// 手動校正——測試站的行為比正式站差,而且從畫面上看不出來。
//
// 本次把後端缺的那半補上(hanlin-ai-composition-api process_task,由環境變數
// SINGLE_CORNERDETECT 控制),前端同步全開,兩個環境行為一致。
//
// ⚠️ 這個 flag 必須與後端的 SINGLE_CORNERDETECT 一起開:
//   只開前端 → 前端不校正、後端也不校正 = 完全沒有校正(就是先前測試站的狀態)
//   只開後端 → 前端仍手動校正、後端再裁一次 = 二次校正(cornerdetect 沒有
//              「已校正就跳過」的判斷,門檻方向還相反,會往內再吃一圈紙邊)
//
// 保留 return true 而不是刪掉整條:舊的手動四角拖曳程式碼原封不動仍在,
// 要退回改這一行即可,不必 revert 加重新部署。
export function isRotateOnlyFlowEnabled(): boolean {
  return true;
}
